module.exports = __webpack_public_path__ + "static/media/trade.3bbf6c8e.png";